import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const ConnectionsApi = {
  index() {
    return http.get(`${orgPath()}/marketplace/integrations`).then((response) => response.data);
  },

  store(data) {
    return http.post(`${orgPath()}/marketplace/integrations`, data).then((response) => response.data);
  },

  show(id) {
    return http.get(`${orgPath()}/marketplace/integrations/${id}`).then((response) => response.data);
  },

  update(id, data) {
    return http.put(`${orgPath()}/marketplace/integrations/${id}`, data).then((response) => response.data);
  },
};
